"use strict";

/** @format */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.badgeArgTypes = exports.badgeParameters = void 0;
// notification-badge.stories.constants.ts
exports.badgeParameters = {
  docs: {
    description: {
      component: 'The Notification Badge provides a small visual indicator for counts or alerts. Supports `dark` and `light` variants.'
    },
    source: {
      code: `<hmf-notification-badge [inputNumber]="inputNumber"></hmf-notification-badge>`
    }
  },
  controls: {
    disabled: false
  },
  options: {
    showPanel: true
  },
  status: {
    type: 'released'
  }
};
exports.badgeArgTypes = {
  inputNumber: {
    control: 'text',
    description: 'The text or number displayed inside the badge.',
    table: {
      type: {
        summary: 'string'
      },
      defaultValue: {
        summary: "''"
      }
    }
  },
  variant: {
    control: {
      type: 'radio'
    },
    options: ['dark', 'light'],
    description: 'Visual style of the badge.',
    table: {
      type: {
        summary: "'dark' | 'light'"
      },
      defaultValue: {
        summary: "'dark'"
      }
    }
  }
};
